import React from "react";
import { Link, NavLink } from "react-router-dom";   // ✅ include NavLink
import { useAuth } from "../context/AuthContext";
import "./Sidebar.css";
import ProviderManual from "../assets/pdfs/Provider_Portal_User_Manual-V1.2.pdf";

const Sidebar = () => {
  const { userType, providerType } = useAuth();

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <h2>Provider Portal Menu</h2>
      </div>
      <ul className="sidebar-menu">
        {userType === "CoreMed Admin" && (
        <li>
          <Link to="/check-eligibility" className="menu-item-link">
            Check Eligibility
          </Link>
        </li>
        )}
        {userType === "Provider User" && (
        <li>
          <Link to="/check-eligibility" className="menu-item-link">
            Check Eligibility/Add Utilization
          </Link>
        </li>
        )}
        {userType === "CoreMed Admin" && (
        <li>
          <Link to="/add-utilization" className="menu-item-link">
            Add Utilization
          </Link>
        </li>
        )}
        {userType === "Provider User" && (
          <li>
            <Link to="/provider-utilization-list" className="menu-item-link">
              Utilization List
            </Link>
          </li>
        )}
        {userType === "Provider User" && (
          <li>
            <Link to="/provider-lab-utilization-list" className="menu-item-link">
              View Lab Utilization
            </Link>
          </li>
        )}
        {userType === "Provider User" && (
          <li>
            <Link to="/provider-users" className="menu-item-link">
              View Users
            </Link>
          </li>
        )}
        {userType === "Provider User" && providerType === "DPC" && (
          <li>
            <NavLink to="/my-members" className="menu-item-link">
              View My DPC Members
            </NavLink>
          </li>
        )}
        <li>
          <a
            href={ProviderManual}
            target="_blank"
            rel="noopener noreferrer"
            className="menu-item-link"
          >
            Provider User Manual V1.2
          </a>
        </li>
      </ul>
    </div>
  );
};

export default Sidebar;
